/**
 * File: apps/qbench-cp/reactapp/src/reportWebVitals.js
 *
 * Purpose: Optionally measures and reports Core Web Vitals metrics for the app.
 *
 * Scope: Performance measurement bootstrap, invoked once from src/index.js.
 *
 * Tags: customer-portal
 *
 * Overview: Accepts a callback function and, if provided, lazily imports the `web-vitals`
 *     package and registers the callback against CLS, FID, FCP, LCP, and TTFB metrics. Does
 *     nothing if no callback (or a non-function) is passed.
 *
 * Exports: default (reportWebVitals)
 */

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
